import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/bodegas-ubicaciones`;

const bodegaUbicacionService = {
  async getAll() {
    const response = await axios.get(apiUrl, {
      headers: { 'Authorization': `Bearer ${utilsService.getToken()}` },
    });
    return response.data;
  },
};

export default bodegaUbicacionService;
